<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Órdenes de Trabajo con Rentabilidad Negativa</strong>
            <p class="descripcion">Órdenes correspondientes a presupuestos cerrados</p>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              description="Fecha de cierre del presupuesto"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              description="Fecha de cierre del presupuesto"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                type="date">
              </b-form-input>
            </b-form-group>

            <!-- <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !proveedor,
                                  'fa fa-remove': proveedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="proveedor"
                  :value="proveedorNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group> -->
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- <b-modal ref="searchProveedorModal"
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal> -->

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
// import SearchProveedor from '../proveedores/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    // appSearchProveedor: SearchProveedor,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  data () {
    return {
      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      // proveedor: null,

      labelCols: 2,
    }
  },
  computed: {
    // proveedorNombre() {
    //   return this.proveedor? this.proveedor.nombre.trim() : '';
    // },
  },
  created() {
    
  },  
  methods: {
    exportXls () {
      this.showSpinner();
      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta
      }

      this.$store.dispatch('ordenestrabajo/getOrdenesRentabilidadNegativa', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptOrdenes = this.$store.getters['ordenestrabajo/resultados'];

          if (rptOrdenes) {
            if (rptOrdenes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Listado de Ordenes';
            let fileName = 'ordenes-rentabilidad-negativa';
            let format = [
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Fecha Cierre', nombre: 'fechaCierre', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Acción', nombre: 'accion', formato: '' },
              { titulo: 'Nro.Orden', nombre: 'id', formato: '' },
              { titulo: 'Rubro', nombre: 'rubroTrabajo', formato: '' },
              { titulo: 'Titulo', nombre: 'titulo', formato: '' },
              { titulo: 'Cotizacion', nombre: 'cotizacion', formato: '' },
              { titulo: 'Costo Real', nombre: 'costoReal', formato: '' }
            ];

            this.exportXLS(title, fileName, rptOrdenes, format);
            
          } else {
            this.showErrorMsj('No hay datos para exportar')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    // seleccionarProveedor() {
    //   if (this.proveedor) {
    //     this.proveedor = null;
    //   } else {
    //     this.$refs.searchProveedorModal.show();
    //   }
    // },
    // proveedorSeleccionado(item) {
    //   this.proveedor = item;
    //   this.$refs.searchProveedorModal.hide();
    // },
  },
}
</script>

<style>
</style>
